<template>
  <div class="postcode-lookup">
    <transition name="fade" mode="out-in">
      <div v-if="!isManual && addressStatus !== 'error'" key="lookup">
        <SmartPostcodeInput
          :icon="icon"
          :icon-hover="iconHover"
          :use-location-pin-icon="useLocationPinIcon"
          :location-pin-icon-color="locationPinIconColor"
          :postcode-success-icon="postcodeSuccessIcon"
          :post-code-btn-theme="postCodeBtnTheme"
          :color-theme="colorTheme"
        />
        <SmartAddressList
          :address-item-icon="addressItemIcon"
          :use-address-item-icon="useAddressItemIcon"
          :prepend-search-icon="prependSearchIcon"
          :placeholder-text="placeholderText"
          :theme="postCodeTheme"
          @submit="submit"
          @manual:show="showManual"
        />
      </div>
      <div v-else key="manual" class="postcode-lookup__manual-form">
        <SmartManualAddressForm
          :button-icon="buttonIcon"
          :btn-shadow="btnShadow"
          :success-icon="successIcon"
          :error-icon="errorIcon"
          :theme="postCodeTheme"
          :label-class="labelClass"
          @submit="submit"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import SmartManualAddressForm from './SmartManualAddressForm'
import SmartPostcodeInput from './SmartPostcodeInput'
import SmartAddressList from './SmartAddressList'

export default {
  name: 'SmartPostcodeLookup',

  components: {
    SmartPostcodeInput,
    SmartManualAddressForm,
    SmartAddressList
  },

  props: {
    value: {
      // Answer
      type: Object,
      required: true
    },
    addressItemIcon: {
      type: String,
      default: 'caret-right-circle.svg'
    },
    useAddressItemIcon: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: null
    },
    iconHover: {
      type: String,
      default: null
    },
    buttonIcon: {
      type: String,
      default: null
    },
    successIcon: {
      type: String,
      default: 'check-circle-green.svg'
    },
    errorIcon: {
      type: String,
      default: 'error-circle.svg'
    },
    useLocationPinIcon: {
      type: Boolean,
      default: true
    },
    locationPinIconColor: {
      type: String,
      default: '#032942'
    },
    postcodeSuccessIcon: {
      type: String,
      default: 'check-circle.svg'
    },
    prependSearchIcon: {
      type: Boolean,
      default: false
    },
    placeholderText: {
      type: String,
      default: 'Search...'
    },
    postCodeBtnTheme: {
      type: String,
      default: ''
    },
    postCodeTheme: {
      type: String,
      default: ''
    },
    labelClass: {
      type: String,
      default: ''
    },
    colorTheme: {
      type: String,
      default: ''
    },
    btnShadow: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      isManual: false
    }
  },

  computed: {
    addressStatus () {
      return this.$store.state.AddressLookup.status
    }
  },

  methods: {
    submit (address) {
      this.$emit('input', { result: address.addressText })
      this.$emit('autoprogress', { result: address.addressText })
      if (address.addressId !== 'manual') { this.$store.dispatch('actionLoadAddress', address.addressId) }
    },

    showManual () {
      this.isManual = true
    }
  }
}
</script>

<style scoped lang="scss">
.postcode-lookup {
  display: block;
  position: relative;
  font-size: 20px;
}
</style>
